document.addEventListener('DOMContentLoaded',()=>{
 const menu=document.querySelector('[data-menu-toggle]'),nav=document.querySelector('[data-mobile-nav]');
 if(menu&&nav){
  menu.addEventListener('click',()=>{const open=nav.classList.toggle('open');menu.setAttribute('aria-expanded',open?'true':'false');document.body.classList.toggle('no-scroll',open)});
  nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');menu.setAttribute('aria-expanded','false');document.body.classList.remove('no-scroll')}));
 }
 document.querySelectorAll('[data-quick-add]').forEach(form=>form.addEventListener('submit',async e=>{
  e.preventDefault();
  const btn=form.querySelector('button');
  if(!btn)return;
  const original=btn.textContent;
  btn.disabled=true;btn.textContent='Adding';
  try{
   const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},body:new URLSearchParams(new FormData(form))});
   if(!res.ok)throw new Error();
   btn.textContent='Added';
   document.dispatchEvent(new CustomEvent('sj:cart-added'));
   setTimeout(()=>btn.textContent=original,1300);
  }catch(err){
   btn.textContent='Try again';
   setTimeout(()=>btn.textContent=original,1300);
  }finally{setTimeout(()=>btn.disabled=false,900)}
 }));
});
